import { render, staticRenderFns } from "./TaxFeatureComponent.vue?vue&type=template&id=3f2f5858&scoped=true&"
import script from "./TaxFeatureComponent.vue?vue&type=script&lang=js&"
export * from "./TaxFeatureComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaxFeatureComponent.vue?vue&type=style&index=0&id=3f2f5858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f5858",
  null
  
)

export default component.exports